import AuthStore from '../auth/store'
import Api, { ApiConfig } from '../api/store'
import I18nStore, { I18nConfig } from '../i18n/store'
import MessageStore from '../message/store'
import { StorageStore } from '../storage'
import { TestStore } from '../test'
import { FirmwareStore } from '../firmware'
import { GeoStore } from '../geo'

export interface Config {
  keychain?: {
    appGroup?: string
  }
  deeplink?: {
    baseUrl?: string
  }
  api?: ApiConfig
  i18n?: I18nConfig
  geo?: {
    apiKey: string
  }
  test_store?: Store
}

class Store {
  readonly i18n: I18nStore
  readonly message: MessageStore
  readonly storage: StorageStore
  readonly auth: AuthStore
  readonly api: Api
  readonly test: TestStore
  readonly firmware: FirmwareStore
  readonly geo: GeoStore

  constructor(config: Config) {
    const { keychain, api, deeplink, geo } = config
    const { baseUrl: deeplinkUrl } = deeplink || {}

    this.storage = new StorageStore(this, keychain) // Needs to be before I18N
    this.i18n = new I18nStore(this) // Needs to be before API
    this.api = new Api(this, api) // Needs to be before Auth
    this.message = new MessageStore(this)
    this.auth = new AuthStore(this, { deeplinkUrl })
    this.test = new TestStore(this)
    this.firmware = new FirmwareStore(this)
    this.geo = new GeoStore(this, geo)
  }

  async init(config: Config) {
    const { i18n } = config
    return Promise.all([this.i18n.init(i18n), this.auth.init(), this.test.init()])
  }
}

export default Store
